import React from 'react';
import './Container.css';

const Container = ({ children }) => {
  return <div className="boxContainer">{children}</div>;
};

export default Container;